export interface ISALARYTAKE_FORMULA {
  costToCompany: number;
  bonus: string;
  bonusPercentage: number;
  bonusAmount: number;
  proTax: number;
  employerPF: number;
  employeePF: number;
  employeeInsurance: number;
  addDeductionA: number;
  addDeductionB: number;
}

export const SALARYTAKE_FORMULA = ({
  costToCompany,
  bonus,
  bonusPercentage,
  bonusAmount,
  proTax,
  employerPF,
  employeePF,
  employeeInsurance,
  addDeductionA,
  addDeductionB,
}: ISALARYTAKE_FORMULA) => {
  const ctc = costToCompany;
  const perc = bonusPercentage;
  const amo = bonusAmount;
  const tax = proTax;
  const erPF = employerPF;
  const eePF = employeePF;
  const ins = employeeInsurance;
  const dedA = addDeductionA;
  const dedB = addDeductionB;
  if (
    ctc < 1000 ||
    ctc > 125e7 ||
    perc < 0 ||
    perc > 100 ||
    amo < 0 ||
    amo > 1e6 ||
    tax < 0 ||
    tax > 1e8 ||
    erPF < 0 ||
    erPF > 1e6 ||
    eePF < 0 ||
    eePF > 1e6 ||
    ins < 0 ||
    ins > 1e10 ||
    dedA < 0 ||
    dedA > 1e6 ||
    dedB < 0 ||
    dedB > 1e6
  ) {
    const res = 0;
    return {
      performance: res,
      grossMonthly: res,
      grossYearly: res,
      netDedMonthly: res,
      netDedAnnual: res,
      netTakeHomeMonthly: res,
      netTakeHomeAnnual: res,
    };
  }
  let perfBonus: number;
  if (bonus == 'PERCENTAGE') perfBonus = Number(ctc * (perc / 100));
  else perfBonus = amo;

  const gpm = (ctc - perfBonus) / 12;
  const gpa = ctc - perfBonus;
  const deductions =
    Number(tax) +
    Number(erPF) +
    Number(eePF) +
    Number(ins) +
    Number(dedA) +
    Number(dedB);
  const annual = deductions * 12;
  const takeMonthly = gpm - deductions;
  const takeAnnual = gpa - annual;
  return {
    performance: Number(perfBonus),
    grossMonthly: Number(gpm),
    grossYearly: Number(gpa),
    netDedMonthly: Number(deductions),
    netDedAnnual: Number(annual),
    netTakeHomeMonthly: Number(takeMonthly),
    netTakeHomeAnnual: Number(takeAnnual),
  };
};
